import { AlergiaSelectFieldModel } from 'components/form/field/select/AlergiaSelectField/AlergiaSelectField'

import { AlergiaReacaoModel } from './model'

export const alergiaIsEqual = (a: AlergiaSelectFieldModel, b: AlergiaReacaoModel) =>
  (b.alergiaId && a.id === b.alergiaId) ||
  (a.substanciaEspecifica?.id ===
    (b.substanciaCbara?.id ?? b.substanciaImunobiologico?.id ?? b.substanciaMedicamento?.medicamento?.id) &&
    a.substanciaEspecifica?.categoria === b.categoriaSubstancia)
